<div class="d-flex flex-column mt-2 position-relative">
  <button
    type="button"
    class="btn btn-primary w-100"
    (click)="startFullAutoTuning.emit()"
    [disabled]="isFullAutoTuningRunning"
  >
    ANALYZE &amp; TUNE AUTOMATICALLY
  </button>
</div>
